<template>
  <div class="wrapper-table table-responsive">
    <table class="table table-hover">
      <thead>
        <tr>
          <th scope="col">Tipo</th>
          <th scope="col">Empresa / CNPJ</th>
          <th scope="col">Identificador</th>
          <th scope="col">Operação</th>
          <th class="text-center" scope="col">Processado</th>
          <th class="text-center" scope="col">Integrado no WBC</th>
          <th scope="col">Detalhe</th>
        </tr>
      </thead>
      <transition-group
        name="list"
        mode="in-out"
        tag="tbody"
        v-if="itens && itens.length > 0"
      >
        <tr :key="`status_item_${itemIndex}`" v-for="(item, itemIndex) in itens">
          <td>{{ TIPO_ITEM_LABEL(item.tipoItem) }}</td>
          <td>
            {{ item.empresaOrigemNome || "-" }}<br />
            <span class="text-secondary">{{ item.cnpjOrigem || "-" }}</span>
          </td>
          <td>{{ item.identificadorSubDado || "-" }}</td>
          <td>
            {{ item.operacao === "TRANSFERIR" ? "Transferir" : "Inativar" }}
            <template v-if="item.operacao === 'TRANSFERIR'">
              <br />
              <span class="text-secondary">
                destino: {{ item.empresaDestinoNome || "-" }} ({{
                  item.cnpjDestino || "-"
                }})
              </span>
            </template>
          </td>
          <td class="text-center">
            <i v-if="item.sucesso" class="icon-check small" />
            <i v-else class="icon-xis large" />
          </td>
          <td class="text-center">
            <i v-if="item.integradoWbc" class="icon-check small" />
            <i v-else class="icon-xis large" />
          </td>
          <td>{{ item.detalheProcessamento || "--" }}</td>
        </tr>
      </transition-group>
      <tbody v-else>
        <tr>
          <td class="text-center" colspan="7">Nenhum registro encontrado</td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
export default {
  props: {
    itens: {
      type: Array,
      required: false,
      default() {
        return new Array();
      },
    },
  },
  methods: {
    TIPO_ITEM_LABEL(tipoItem) {
      return (
        {
          CONTATO: "Contato",
          SIGLA_CCEE: "Sigla CCEE",
          UC: "UC",
        }[tipoItem] || tipoItem
      );
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/style/style.scss";
@import "@/assets/style/colors.scss";

th {
  font-weight: 500;
}

.list-enter-active,
.list-leave-active {
  transition: opacity 0.3s;
}

.list-enter,
.list-leave-to {
  opacity: 0;
}
</style>
